import { useRef } from 'react';
// import call from '~/assets/icons/call.svg';
import message from '~/assets/icons/message.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { PhoneApps } from '~/shared';
import { ContactsStages } from '../../models/Contacts';
import { MessengerStages } from '../../models/Messenger';
import {
	setActiveApp,
	setActiveContactsState,
	setActiveMessengerState,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledButtonsContainer,
	StyledContainer,
	StyledImage,
	StyledImageButton,
	StyledLeftContainer,
	StyledNameOnlineContainer,
} from './AppMessengerPlayerCard.styled';

const AppMessengerPlayerCard = ({
	nickname,
	online,
	favorite,
	phoneNumber,
}: {
	nickname: string;
	online?: boolean;
	favorite?: boolean;
	phoneNumber?: string;
}) => {
	const dispatch = useLayoutDispatch();
	const buttonsContainerRef = useRef<HTMLDivElement>(null);
	const dialogs = useObservable(rage.messages.getDialogs());

	{
		/* Выпадающее меню */
	}
	// const [dropdownVisible, setDropdownVisible] = useState(false);

	// const dropDownMenuItems: IDropdownMenuItem[] = useMemo(
	// 	() => [
	// 		{
	// 			title: favorite ? 'Удалить из избранного' : 'Добавить в избранное',
	// 			icon: favorite ? cross : star,
	// 			onClick: () => console.log('--favorite', nickname),
	// 		},
	// 		{
	// 			title: 'Добавить в друзья',
	// 			icon: plusRound,
	// 			onClick: () => console.log('--add', nickname),
	// 		},
	// 		{
	// 			title: 'Заблокировать',
	// 			icon: ban,
	// 			onClick: () => console.log('--ban', nickname),
	// 		},
	// 	],
	// 	[nickname, favorite],
	// );

	const handleOpenDialog = async (e: React.MouseEvent<HTMLImageElement>) => {
		e.stopPropagation();

		if (phoneNumber) {
			const dialog = dialogs.find((d) => d.peer.phoneNumber === phoneNumber);

			if (dialog) {
				rage.messages.setActiveDialogId(dialog.id);
			} else {
				try {
					const dialogId = await rage.messages.createDialog(phoneNumber, '');
					rage.messages.setActiveDialogId(dialogId);
				} catch (error) {
					rage.notifications.showException(error);
				}
			}
		}

		dispatch(setActiveApp(PhoneApps.MESSENGER));
		dispatch(setActiveMessengerState(MessengerStages.DIALOG));
	};

	// пока не понятно, будет ли использоваться, оставим на будущее
	// const handleCall = (e: React.MouseEvent<HTMLImageElement>) => {
	// 	e.stopPropagation();
	// 	if (phoneNumber) {
	// 		rage.phoneCalls
	// 			.call(phoneNumber)
	// 			.catch((err) => rage.notifications.showException(err));
	// 	}
	// };

	const handleContainerClick = (event: React.MouseEvent) => {
		if (
			buttonsContainerRef.current &&
			buttonsContainerRef.current.contains(event.target as Node)
		) {
			return;
		}

		dispatch(setActiveContactsState(ContactsStages.INFO_CONTACT));
	};

	return (
		<StyledContainer
			$online={online}
			$favorite={favorite}
			onClick={handleContainerClick}
		>
			<StyledLeftContainer>
				<StyledImage $online={online} />
				<StyledNameOnlineContainer $online={online}>
					<Text className={'name'}>{nickname}</Text>
					<Text className={'online'}>{online ? 'Онлайн' : 'Не в сети'}</Text>
				</StyledNameOnlineContainer>
			</StyledLeftContainer>
			<StyledButtonsContainer ref={buttonsContainerRef}>
				{/* {phoneNumber && online && (
					<StyledImageButton
						src={call}
						width={20}
						height={20}
							onClick={(e) => {
								handleCall(e);
								playSound(Sound.ClickButton);
							}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					/>
				)} */}
				<StyledImageButton
					src={message}
					width={20}
					height={20}
					onClick={(e) => {
						handleOpenDialog(e);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
				{/* Выпадающее меню */}
				{/* <StyledImageButton
					src={dots}
					width={20}
					height={20}
					onClick={() => setDropdownVisible(true)}
				/> */}
			</StyledButtonsContainer>
			{/* Выпадающее меню */}
			{/* <CSSTransition
				in={dropdownVisible}
				timeout={300}
				classNames={'menu'}
				unmountOnExit
			>
				<StyledDropdownWrapper>
					<DropdownMenu
						items={dropDownMenuItems}
						closeHandler={() => setDropdownVisible(false)}
					/>
				</StyledDropdownWrapper>
			</CSSTransition> */}
		</StyledContainer>
	);
};

export { AppMessengerPlayerCard };
